export const GET_RETURNS_STATS = 'GET_RETURNS_STATS';
export const GET_RETURNS = 'GET_RETURNS';
export const SET_LOADER = 'SET_LOADER';
export const MUTATE_PROCESS = 'MUTATE_PROCESS';
export const LOCAL_MUTATE = 'LOCAL_MUTATE';
export const ADD_UUIDS = 'ADD_UUIDS';
export const SET_SPARE_ID = 'SET_SPARE_ID';
export const RESET_UUIDS = 'RESET_UUIDS';
export const MASTER_RESET = 'MASTER_RESET';